export default "__VITE_ASSET__D0wGBpb1__"